import { MonoTypeOperatorFunction } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * Same behavior as distinctUntilChanged but specifically for arrays where the comparator is used to compare elements of
 * the arrays.
 *
 * Returns a result Observable that emits all arrays pushed by the source observable if their elements are distinct in
 * comparison to the elements the result observable emitted previously.
 *
 * @param comparator Optional comparison function that is used to compare elements of the arrays. Default is ===.
 */
export function arrayDistinctUntilChanged<T>(comparator?: (a: T, b: T) => boolean): MonoTypeOperatorFunction<T[]> {
  return distinctUntilChanged<T[]>((as, bs) => arrayContentEqual(as, bs, comparator));
}

export function arrayContentEqual<T>(as: T[], bs: T[], comparator?: (a: T, b: T) => boolean) {
  return as.length === bs.length && as.every((a) => bs.some((b) => (comparator ? comparator(a, b) : a === b)));
}
